export default {
  getPaysById:  (state,  id)  => {
    return state.pays.find((p) => p._id === id)
  }
}